import { Anchor } from "@mantine/core";

import classes from "./index.module.css";

interface IFooterAnchor {
  text: string;
  href: string;
  white?: boolean;
  center?: boolean;
}

const FooterAnchor = ({ href, text, white, center }: IFooterAnchor) => {
  return (
    <Anchor
      href={href}
      className={`${classes.anchor} ${white ? classes.white : ""} ${center ? classes.center : ""}`}
    >
      {text}
    </Anchor>
  );
};

export default FooterAnchor;
